<template>
    <div>
        <h1>Setup</h1>

        <div class="mt-5 mb-3">
            <div>
                <hotelDropdown v-show="user.role != 4" v-bind:append_to_body="false" v-bind:current_stay="''" v-on:onChangeHotel="onChangeHotel"></hotelDropdown>
            </div>

            <div v-if="user.role == 4">
                <h3>{{ user.staff_info.hvg_desc }}</h3>
            </div>
        </div>

        <vx-card v-if="hotel_id != '' && menus.length == 0" class="mt-5">
            <div>
                <p align="center">Não foram encontradas cartas para o hotel selecionado.</p>
            </div>
        </vx-card>

        <div v-if="show_menu == false">
            <div v-if="menus.length > 0">
                <vs-divider color="primary" position="left">Carta</vs-divider>
            
                <div class="px-2 m-5" v-for="(menu, index) in menus" :key="index" v-if="menu.type == 'Carta'">
                    
                    <div class="flex flex-wrap -mx-2">
                        <div class="sm:w-full md:w-1/3 lg:w-1/4 p-2" v-for="(item, index) in convertToBool(menu.idiomas)" :key="index">
                            <vx-card>
                                <div slot="no-body">
                                    <img v-if="menu.image_path !== null" :src="menu.image_path" alt="content-img" class="responsive card-img-top">
                                    <img v-else :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div>
                                    <h5>{{ item.name + ' » ' + item.language }}</h5>
                                </div>
                                <div class="clearfix">
                                    <div>
                                        <vs-button class="mt-4 w-full" type="filled" color="primary" v-on:click="seeMenu(item, menu.currency, menu.type)">Ver</vs-button>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>

                <vs-divider color="primary" position="left">Menu</vs-divider>
                
                <div class="px-2 m-5" v-for="(menu, index) in menus" :key="index" v-if="menu.type == 'Menu'">
                    
                    <div class="flex flex-wrap -mx-2">
                        <div class="sm:w-full md:w-1/3 lg:w-1/4 p-2" v-for="(item, index) in convertToBool(menu.idiomas)" :key="index">
                            <vx-card>
                                <div slot="no-body">
                                    <img v-if="menu.image_path !== null" :src="menu.image_path" alt="content-img" class="responsive card-img-top">
                                    <img v-else :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div>
                                    <h5>{{ item.name + ' » ' + item.language }}</h5>
                                </div>
                                <div class="clearfix">
                                    <div>
                                        <vs-button class="mt-4 w-full" type="filled" color="primary" v-on:click="seeMenu(item, menu.currency, menu.type)">Ver</vs-button>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>

                <vs-divider color="primary" position="left">Directório</vs-divider>
                
                <div class="px-2 m-5" v-for="(menu, index) in menus" :key="index" v-if="menu.type == 'Directório'">
                    
                    <div class="flex flex-wrap -mx-2">
                        <div class="sm:w-full md:w-1/3 lg:w-1/4 p-2" v-for="(item, index) in convertToBool(menu.idiomas)" :key="index">
                            <vx-card>
                                <div slot="no-body">
                                    <img :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div>
                                    <h5>{{ item.name + ' » ' + item.language }}</h5>
                                </div>
                                <div class="clearfix">
                                    <div>
                                        <vs-button class="mt-4 w-full" type="filled" color="primary" v-on:click="seeMenu(item, menu.currency, menu.type)">Ver</vs-button>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>

                <vs-divider color="primary" position="left">Marcação</vs-divider>
                
                <div class="px-2 m-5" v-for="(menu, index) in menus" :key="index" v-if="menu.type == 'Marcação'">
                    
                    <div class="flex flex-wrap -mx-2">
                        <div class="sm:w-full md:w-1/3 lg:w-1/4 p-2" v-for="(item, index) in convertToBool(menu.idiomas)" :key="index">
                            <vx-card>
                                <div slot="no-body">
                                    <img :src="require('@/assets/images/default_menu.jpg')" alt="content-img" class="responsive card-img-top">
                                </div>
                                <div>
                                    <h5>{{ item.name + ' » ' + item.language }}</h5>
                                </div>
                                <div class="clearfix">
                                    <div>
                                        <vs-button class="mt-4 w-full" type="filled" color="primary" v-on:click="seeMenu(item, menu.currency, menu.type)">Ver</vs-button>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="show_menu == true">
            <vs-button class="float-right" type="filled" color="primary" v-on:click="goBackToMenus()">{{ $t('returnButton') }}</vs-button>
            <h2 class="my-5">{{ selected_menu.name + ' » ' + selected_menu.language  }}</h2>
            <vx-card>
                <vs-tabs>
                    <vs-tab v-for="(c, index) in convertToBool(selected_menu.capitulos)" :key="index" :label="c.name">
                        <div class="flex flex-wrap my-5">
                            Estado:
                            <vs-switch class="ml-3" color="success" v-model="c.visibility"  v-on:click="changeStatus(c.id, c.visibility, 'chapter')">
                                <span slot="on">Visível</span>
                                <span slot="off">Invisível</span>
                            </vs-switch>
                        </div>
                        <div>
                            <p align="center" v-if="c.sub_capitulos.length == 0">
                                Não foram encontrados subcapítulos para este capítulo.
                            </p>
                            <vs-table v-if="c.sub_capitulos.length > 0" stripe :data="c.sub_capitulos">
                                <template slot="thead">
                                    <vs-th class="sm:w-3/6 lg:w-3/6">Descrição</vs-th>
                                    <vs-th class="sm:w-1/6 lg:w-1/6">Preço</vs-th>
                                    <vs-th class="sm:w-1/6 lg:w-1/6">Estado</vs-th>
                                    <vs-th v-if="['Directório', 'Marcação'].indexOf(type) === -1" class="sm:w-1/6 lg:w-1/6">Room Service</vs-th>
                                </template>

                                <template>
                                    <vs-tr :key="indextr" v-for="(item, indextr) in convertToBool(c.sub_capitulos)">
                                        <vs-td :data="item.nome">
                                            <strong>{{ item.nome }}</strong>
                                            <br />
                                            <em>{{ item.descricao }}</em>
                                        </vs-td>

                                        <vs-td v-if="item.sub_capitulo_medidas.length <= 0" :data="item.preco">
                                            <div class="">
                                                {{ item.preco != 0 && item.preco != null && item.preco != '' ?  parseFloat(item.preco).toFixed(2) + ' ' + currency : 'N/A' }}
                                            </div>
                                        </vs-td>

                                        <vs-td v-if="item.sub_capitulo_medidas.length <= 0">
                                            <vs-switch color="success" v-model="item.visibility"  v-on:click="changeStatus(item.id, item.visibility, 'sub-chapter')">
                                                <span slot="on">Visível</span>
                                                <span slot="off">Invisível</span>
                                            </vs-switch>
                                        </vs-td>

                                        <vs-td v-if="item.sub_capitulo_medidas.length <= 0 && ['Directório', 'Marcação'].indexOf(type) === -1">
                                            <vs-switch color="success" v-model="item.room_service"  v-on:click="changeRoomService(item.id, item.room_service, 'subchapter')">
                                                <span slot="on">Activo</span>
                                                <span slot="off">Inactivo</span>
                                            </vs-switch>
                                        </vs-td>

                                        <vs-td v-if="item.sub_capitulo_medidas.length > 0" :data="item.sub_capitulo_medidas">
                                            <div class="mb-2" v-for="(m, index) in convertToBool(item.sub_capitulo_medidas)" :key="index">
                                                <span class="mb-2">
                                                    {{ m.volume + ' ' + m.medida }}
                                                    {{ m.preco != 0 && m.preco != '' && m.preco != null ? ' | ' + parseFloat(m.preco).toFixed(2) + ' ' + currency : 'N/A' }}
                                                </span>
                                            </div>
                                        </vs-td>

                                        <vs-td v-if="item.sub_capitulo_medidas.length > 0">
                                            <vs-switch class="mb-2" v-for="(m, index) in convertToBool(item.sub_capitulo_medidas)" :key="index" color="success" v-model="m.visibility"  v-on:click="changeStatus(m.id, m.visibility, 'measure')">
                                                <span slot="on">Visível</span>
                                                <span slot="off">Invisível</span>
                                            </vs-switch>
                                        </vs-td>

                                        <vs-td v-if="item.sub_capitulo_medidas.length > 0 && ['Directório', 'Marcação'].indexOf(type) === -1">
                                            <vs-switch class="mb-2" v-for="(m, index) in convertToBool(item.sub_capitulo_medidas)" :key="index" color="success" v-model="m.room_service"  v-on:click="changeRoomService(m.id, m.room_service, 'measure')">
                                                <span slot="on">Ativo</span>
                                                <span slot="off">Inativo</span>
                                            </vs-switch>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </vs-tab>
                </vs-tabs>
            </vx-card>
        </div>
    </div>
</template>

<script>
//load hotel dropdown from components
import HotelDropdown from '@/views/components/HotelDropdown.vue'

export default {
    data() {
        return {
            menus: [],
            card_1: {
                contentImg1: 'content-img-1.jpg',
                title: 'Menu',
                changeHotel: '',
                user_hotel_name: '',
                current_stays: '',
            },
            current_stay_hotel: '',
            selected_menu: '',
            show_menu: false,
            currency: '',
            type: '',
            user: JSON.parse(window.localStorage.getItem('userSession')),
            hotel_id: ''
        }
    },
    methods: {
        onChangeHotel(newHotel) {
            this.changeHotel = newHotel;
            this.hotel_id = newHotel;
            this.getMenus(newHotel);
            this.goBackToMenus();
        },

        seeMenu(menu, currency, type) {
            let that = this;
            that.$vs.loading();

            this.$api({
                method: 'get',
                url: '/myvilagale/hotel/get_menu_data?token=' +this.user.usertoken,
                params: {
                    id: menu.menu_id,
                    hotel_id: this.hotel_id,
                    lang: menu.language,
                    setup : true
                },
            })
            .then(function (res) {
                if(typeof res.data.capitulos === 'undefined' || res.data.capitulos.length == 0) {
                    that.$vs.notify({
                        text: 'Não foram encontrados capítulos para o idioma seleccionado.',
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                    that.$vs.loading.close();
                    return false;
                }
                that.selected_menu = res.data;
                that.show_menu = true;
                that.type = type;

                if(res.data.menu.currency == 'Euro'){
                    that.currency = '€';
                } else if(res.data.menu.currency == 'Real'){
                    that.currency = 'R$';
                } else {
                    that.currency = '$';
                }

                that.$vs.loading.close();
            }) 
            
            
        },
        goBackToMenus() {
            this.show_menu = false;
            this.selected_menu = '';
            this.type = '';
        },

        changeRoomService(id, room_service, type) {
            this.$vs.loading();
            let params = {
                id: id,
                room_service: room_service == true ? 0 : 1,
                type: type
            }
            
            let that = this;
            
            this.$api.put( '/myvilagale/hotel/menu/set-room-service?token=' + localStorage.getItem('usertoken'),
                params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                }).then(function(res) {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        text: 'Room Service alterado com sucesso.',
                        color:'success',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-check'
                    });
                })
                .catch(function(err) {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        text: 'Erro ao atualizar Room Service.',
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                });    
        },
    },
    created() {
        this.user = JSON.parse(window.localStorage.getItem('userSession'));

        if (this.user.hotel && this.user.role == 4) {
            this.hotel_id = this.user.staff_info.hvg_id;
            this.getMenus(this.hotel_id);
        }
    },
    components: {
        HotelDropdown,
    }
}
</script>

<style>
    .hotel_selection {
        margin-bottom: 25px;
    }

    .dropdown {
        margin-top: 25px;
    }

    .options_block {
        display: flex;
    }

    .element_button {
        margin-top: 19px;
        margin-left: 25px;
    }

    @media screen and (max-width: 450px) {
        .vs-table--tbody-table {
            width: 1000px !important;
        }
    }
</style>
